import { manageProjectsExperienceId } from '@atlassian/help-center-common-util/analytics/ufo';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

export const manageProjectsExperience = new UFOExperience(manageProjectsExperienceId, {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageLoad,
});
